import * as toastr from 'toastr';
import {ACTION_TYPES, createAction} from "../actions";
import { call, put, takeEvery} from 'redux-saga/effects'
import {updateEntityGeometryByFullUid} from "../../http/updateEntityGeometryByFullUid";
import {getGeomStringForFeature} from "../../utils/getGeomStringForFeature";
import {IFeature_CONO, IGeometryNode} from "../../types";

export function* updateEntityGeometrySaga () {
    yield takeEvery(ACTION_TYPES.UPDATE_ENTITY_GEOMETRY, _updateEntityGeometry);
}

function* _updateEntityGeometry (action: any) {
    const payload: {type: string, fullUid: string, feature: IFeature_CONO, entity: any} = action.payload;
    console.log(action);
    try {
        const {type, fullUid, feature, entity} = payload;
        const theGeom = getGeomStringForFeature(feature);
        // const geoType = getGeoType(feature);
        const patch: any = {
            // theGeom
            // fullUid,
            // geoType,
            // type,
            theGeom
        }
        // yield put(createAction(ACTION_TYPES.UPDATE_ENTITY_GEOMETRY_SUCCESS, {
        //     fullUid, type, feature, entity, geometry: feature.geometry
        // }));
        const entityGeometry: IGeometryNode = yield call(updateEntityGeometryByFullUid, fullUid, patch);
        console.log(entityGeometry);
        if (entityGeometry) {
            toastr.success('Updated geometry for entity ' + feature.properties.name || '');
        }
        yield put(createAction(ACTION_TYPES.UPDATE_ENTITY_GEOMETRY_SUCCESS, {
            fullUid, type, feature, entity, geometry: feature.geometry
        }));
    } catch (error) {
        toastr.error('Error updating geometry');
        yield put(createAction(ACTION_TYPES.UPDATE_ENTITY_GEOMETRY_ERROR, {error}));
    }
}

